<mat-toolbar class="toolbar">
  <mat-toolbar-row fxLayout="row" fxFlex>

    <!-- Logo for different sizes -->
    <div fxShow.lt-md fxHide.gt-sm style="width:50px; margin-top:10px;" fxFlex>
      <img *ngIf="imageSource" src={{imageSource}}
           style="width: 50px; height:50px;" alt="">

      <img *ngIf="!imageSource" src='assets/images/defaultLogo.png'
           style="width: 50px; height:50px;" alt="">
    </div>

    <div fxFlex fxShow.gt-sm fxHide.lt-md style="width:50px; margin-top:10px;">
      <img *ngIf="imageSource" src={{imageSource}}
           style="width: 50px; height:50px;" alt="">
      <img *ngIf="!imageSource" src='assets/images/defaultLogo.png'
           style="width: 50px; height:50px;" alt="">

    </div>
    <!--  -->


    <div fxLayoutAlign="end center" fxFlexAlign="center center">
      <mat-menu #appMenu="matMenu" class="menuContainer">
        <div class="menuContent" fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="center center">
            <img src="assets/images/avatar.png" alt="" class="userAvatar"/>
          </div>

          <mat-divider></mat-divider>


          <div fxLayout="row" class="buttons">
            <button mat-menu-item (click)="commonService.logout()">
              <mat-icon class="logout">exit_to_app</mat-icon>
              Αποσύνδεση
            </button>
          </div>
        </div>
      </mat-menu>

      <button mat-flat-button [matMenuTriggerFor]="appMenu" class="infoButton">
        {{user.firstName}} {{user.lastName}}
      </button>
    </div>

  </mat-toolbar-row>
</mat-toolbar>

<div style="margin-top:60px;">
  <div fxLayout="column" style="padding:15px;">

    <app-page-header [title]="pageTitle" action=''></app-page-header>
    <div *ngIf="isUserInfoLoading || isProvidersLoading">
      <app-loading></app-loading>
    </div>
    <div style="margin-top: 80px; padding: 15px;" *ngIf="!isUserInfoLoading && !isProvidersLoading">

      <mat-horizontal-stepper linear #stepper>

        <mat-step [stepControl]="firstFormGroup">
          <form [formGroup]="firstFormGroup">
            <ng-template matStepLabel>Επιβεβαίωση</ng-template>

            <div fxLayout="column">
              <div style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                Καλωσήρθατε στην εφαρμογή eApply.<br/> Στη συνέχεια θα σας ζητήσουμε να συμπληρώσετε ορισμένα στοιχεία
                για να ολοκληρωθεί η διαδικασία της εγγραφής σας. Η όλη διαδικασία δεν θα πάρει πάνω από 2 λεπτά.
              </div>

              <div fxLayout="row" fxLayoutGap="20px" style="margin-top: 50px;">
                <mat-form-field appearance="legacy" class="inputClass">
                  <mat-label>Όνομα</mat-label>
                  <input matInput placeholder="Όνομα" formControlName="firstName" readonly required>

                </mat-form-field>
                <mat-form-field appearance="legacy" class="inputClass">
                  <mat-label>Επώνυμο</mat-label>
                  <input matInput placeholder="Επώνυμο" formControlName="lastName" readonly required>
                </mat-form-field>
              </div>
              <div fxFlex fxLayout="row">
                <div fxFlex>
                  <!--          <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>-->
                </div>

                <div>
                  <button mat-raised-button class="stepperButton" matStepperNext>Επόμενο</button>
                </div>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup">
          <form [formGroup]="secondFormGroup">
            <ng-template matStepLabel>Email</ng-template>
            <div fxFlex="column" style="margin-top: 20px;">
              <div fxLayout="row" style="width: 100%;" fxLayoutGap="30px;">

                <div fxLayout="column" fxFlex="50"
                     style="font-family: 'Century Gothic', sans-serif; margin-top: 50px; margin-bottom: 10px; font-size: 14px;">

                  <span style="margin-top: 10px; margin-bottom: 10px;">Επιλέξτε το email με το οποίο θα συνδέεστε στην εφαρμογή (username).</span>
                  <span style="margin-top: 10px; margin-bottom: 10px;"> Πατήστε «Αποστολή Κωδικού» για να σας σταλεί ένας κωδικός επαλήθευσης στο email αυτό. </span>

                  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">
                    <mat-form-field *ngIf="userHasEmail()" appearance="legacy" class="inputClass">
                      <mat-label>Email</mat-label>
                      <mat-select formControlName="selectedEmail">
                        <mat-option *ngFor="let email of currentUser.declaredEmails" [value]="email">
                          {{email}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="!userHasEmail()" appearance="legacy" class="inputClass">
                      <mat-label>Email</mat-label>
                      <input matInput placeholder="Email" formControlName="selectedEmail">
                    </mat-form-field>
                    <button (click)="requestCode()" style=""
                            [disabled]="!secondFormGroup.controls.selectedEmail.value || !secondFormGroup.controls.selectedEmail.valid || requestLoading" mat-raised-button
                            [class.spinner]="requestLoading"
                            class="stepperButton">Αποστολή κωδικού
                    </button>
                  </div>
                </div>

                <div *ngIf="requestedCode" fxLayout="column" fxFlex="40" fxLayoutAlign="start start start"
                     style="font-family: 'Century Gothic', sans-serif; margin-top: 50px; margin-bottom: 10px; font-size: 14px;">

                  <div>
                    <span style="margin-top: 10px; margin-bottom: 10px;">Εισάγετε τον 6ψήφιο κωδικό που λάβατε στο email σας και πατήστε το πλήκτρο «Επαλήθευση»</span>

                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">

                      <mat-form-field appearance="legacy" class="inputClass">
                        <mat-label>Κωδικός 2 βημάτων</mat-label>
                        <input matInput formControlName="otpCode"/>
                      </mat-form-field>
                      <button (click)="verifyCode()" mat-raised-button class="stepperButton" [disabled]="!this.secondFormGroup.controls.otpCode.value || requestLoading"  [class.spinner]="requestLoading">Επαλήθευση
                      </button>
                    </div>
                    <div fxLayout="column" style='margin-top: 10px; margin-bottom: 20px;'>
                      <span style="margin-top: 10px; margin-bottom: 10px;">Αν δεν λάβατε τον κωδικό εντός 2 λεπτών, μπορείτε να ζητήσετε νέο κωδικό επιλέγοντας «Επαναποστολή κωδικού»</span>
                      <div>
                        <button (click)="requestCode()" mat-raised-button class="stepperButton">
                          Επαναποστολή κωδικού
                        </button>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex>
                  <button mat-raised-button class="stepperButton" matStepperPrevious>Προηγούμενο</button>
                </div>

                <div>
                  <button [disabled]="!this.secondFormGroup.controls.confirmedCode.value" mat-raised-button
                          class="stepperButton" matStepperNext>Επόμενο
                  </button>
                </div>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="thirdFormGroup">
          <form [formGroup]="thirdFormGroup">
            <ng-template matStepLabel>Kινητό</ng-template>
            <div fxFlex="column" style="margin-top: 20px;">
              <div fxLayout="row" style="width: 100%;" fxLayoutGap="30px;">

                <div fxLayout="column" fxFlex="50"
                     style="font-family: 'Century Gothic', sans-serif; margin-top: 50px; margin-bottom: 10px; font-size: 14px;">

                  <span
                    style="margin-top: 10px; margin-bottom: 10px;">Εισάγετε τον αριθμό του κινητού τηλεφώνου σας.</span>
                  <span style="margin-top: 10px; margin-bottom: 10px;"> Πατήστε «Αποστολή Κωδικού» για να σας σταλεί ένας κωδικός επαλήθευσης στον αριθμό αυτό.
            Για αριθμό κινητού Ελλάδος εισάγετε τον αριθμό 69. Για αριθμό κινητού τηλεφώνου εξωτερικού, εισάγετε πρώτα 00, στη συνέχεια τον κωδικό της χώρας και στη συνέχεια τον αριθμό κινητού του εξωτερικού </span>
                  <div>

                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">
                      <mat-form-field appearance="legacy" class="inputClass">
                        <mat-label>Αριθμός κινητού</mat-label>
                        <input formControlName="mobile" matInput placeholder="Κινητό τηλέφωνο"
                               required>
                      </mat-form-field>

                      <button (click)="requestMobileCode()" class="stepperButton"
                              [class.spinner]="requestLoading"
                              [disabled]="!thirdFormGroup.controls.mobile.value || requestLoading" mat-raised-button>Αποστολή
                        κωδικού
                      </button>
                    </div>
                  </div>
                </div>

                <div *ngIf="requestedMobileCode" fxLayout="column" fxFlex="40" fxLayoutAlign="start start start"
                     style="font-family: 'Century Gothic', sans-serif; margin-top: 50px; margin-bottom: 10px; font-size: 14px;">

                  <div>
                    <span style="margin-top: 10px; margin-bottom: 10px;">Εισάγετε τον 6ψήφιο κωδικό που λάβατε στο κινητό σας και πατήστε το πλήκτρο «Επαλήθευση»</span>

                    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center center">

                      <mat-form-field appearance="legacy" class="inputClass">
                        <mat-label>Κωδικός 2 βημάτων</mat-label>
                        <input matInput formControlName="otpCode"/>
                      </mat-form-field>
                      <button (click)="verifyMobileCode()" mat-raised-button class="stepperButton" [disabled]="!this.thirdFormGroup.controls.otpCode.value || requestLoading">Επαλήθευση
                      </button>
                    </div>
                    <div fxLayout="column" style='margin-top: 10px; margin-bottom: 20px;'>
                      <span style="margin-top: 10px; margin-bottom: 10px;">Αν δεν λάβατε τον κωδικό εντός 2 λεπτών, μπορείτε να ζητήσετε νέο κωδικό επιλέγοντας «Επαναποστολή κωδικού»</span>
                      <div>
                        <button (click)="requestMobileCode()" mat-raised-button class="stepperButton">
                          Επαναποστολή κωδικού
                        </button>
                      </div>
                    </div>
                  </div>


                </div>
              </div>


              <div fxLayout="row">
                <div fxFlex>
                  <button class="stepperButton" mat-raised-button matStepperPrevious>Προηγούμενο</button>
                </div>

                <div>
                  <button [disabled]="!this.thirdFormGroup.controls.confirmedCode.value" mat-raised-button
                          class="stepperButton" matStepperNext>Επόμενο
                  </button>
                </div>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step *ngIf="loginProvider !== 'ldap'" [stepControl]="fourthFormGroup">
          <form [formGroup]="fourthFormGroup">
            <ng-template matStepLabel>Δημιουργία μυστικού κωδικού</ng-template>
            <div fxLayout="column">
              <div fxLayout="row" fxLayoutGap="20px">

                <div fxLayout="column">
                <span style="margin-top: 10px; margin-bottom: 10px;">Προσωρινός κωδικός</span>
                <mat-form-field appearance="legacy" class="inputClass">
                  <mat-label>Προσωρινός κωδικός</mat-label>
                  <input type="password" matInput formControlName="tempPassword"
                         required (focusout)="validateTempPassword()">
                </mat-form-field>
                </div>

                <div fxLayout="column">
                <span style="margin-top: 10px; margin-bottom: 10px;">Νέος μυστικός κωδικός</span>
                <mat-form-field appearance="legacy" class="inputClass">
                  <mat-label>Κωδικός</mat-label>
                  <input matInput type="password" formControlName="password"
                         required>
                </mat-form-field>


                <mat-password-strength #passwordComponent class="inputClass"
                                       [password]="fourthFormGroup.controls.password.value"></mat-password-strength>
                </div>
<!--                <mat-password-strength-info class="inputClass" [passwordComponent]="passwordComponent"-->
<!--                                            lowerCaseCriteriaMsg="Τουλάχιστον 1 μικρό γράμμα"-->
<!--                                            upperCaseCriteriaMsg="Τουλάχιστον 1 κεφαλαίο γράμμα"-->
<!--                                            specialCharsCriteriaMsg="Τουλάχιστον 1 ειδικός χαρακτήρας ( ! @ # $ % & * )"-->
<!--                                            digitsCriteriaMsg="Τουλάχιστον 1 αριθμό"-->
<!--                                            minCharsCriteriaMsg="Τουλάχιστον 8 χαρακτήρες">-->
<!--                </mat-password-strength-info>-->

                <div fxLayout="column">
                <span style="margin-top: 10px; margin-bottom: 10px;">Επιβεβαίωση νέου μυστικού κωδικού</span>
                <mat-form-field appearance="legacy" class="inputClass">
                  <mat-label>Επιβεβαίωση κωδικού</mat-label>
                  <input type="password" matInput formControlName="confirmPassword"
                         required>
                </mat-form-field>
                </div>
              </div>
              <div fxFlex fxLayout="row">
                <div fxFlex>
                  <button mat-raised-button class="stepperButton" matStepperPrevious>Προηγούμενο</button>
                </div>

                <div>
                  <button [disabled]="passwordsInvalid()" mat-raised-button class="stepperButton" matStepperNext>Επόμενο
                  </button>
                </div>
              </div>
            </div>

          </form>
        </mat-step>
        <mat-step [stepControl]="fifthFormGroup">
          <form [formGroup]="fifthFormGroup">
            <ng-template matStepLabel>Ορισμός προεπιλογής</ng-template>
            <div fxLayout="column">
        <span style="margin-top: 10px; margin-bottom: 10px; font-family: 'Century Gothic', sans-serif;">H εφαρμογή αξιοποιώντας τη σύγχρονη τεχνολογία, εφαρμόζει κατά τη συμπλήρωση των αιτήσεων τη διαδικασία επαλήθευσης 2 βημάτων (γνωστή ως και έλεγχος ταυτότητας δύο παραγόντων) για σας προστατεύει από ανεπιθύμητες ενέργειες. Η αποστολή των Κωδικών 2 βημάτων πραγματοποιείται είτε στο κινητό σας με SMS είτε στο Email σας.
Θέλω οι κωδικοί 2 βημάτων να αποστέλλονται στο:
</span>
              <div fxLayout="row">
                <mat-form-field appearance="legacy" class="inputClass">
                  <mat-label>Επιθυμητό μέσο λήψης ειδοποιήσεων</mat-label>
                  <mat-select formControlName="provider">
                    <mat-option *ngFor="let provider of notificationProviders"
                                [value]="provider">{{provider.description}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxLayout="row">
                <span style="margin-top: 10px; margin-bottom: 10px; font-family: 'Century Gothic', sans-serif;">Μπορείτε να αλλάξετε την επιλογή σας αυτή από το μενού Ρυθμίσεις</span>
              </div>
              <div fxFlex fxLayout="row">
                <div fxFlex>
                  <button mat-raised-button class="stepperButton" matStepperPrevious>Προηγούμενο</button>
                </div>

                <div>
                  <button mat-raised-button class="stepperButton" (click)="submitUser()" [disabled]="!fifthFormGroup.controls.provider.value">Ολοκλήρωση</button>
                </div>
              </div>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</div>
<!--<div style="margin-top:60px;">-->
<!--  <div fxLayout="column" style="padding:15px;">-->

<!--    <app-page-header [title]="pageTitle" action=''></app-page-header>-->

<!--    <div *ngIf="!isInfoLoading" fxLayout="column" fxFlex fxLayoutAlign="center center center" style="margin-top:45px;" fxLayoutGap="10px">-->

<!--      <div fxLayout="row" fxFlex fxLayoutAlign="start center center" ngStyle.gt-sm="width:55%" ngStyle.lt-md="width:100%">-->
<!--        Είναι η πρώτη φορά που συνδέεστε στο e-Apply.-->
<!--      </div>-->
<!--      <div fxLayout="row" fxFlex fxLayoutAlign="start center center" ngStyle.gt-sm="width:55%" ngStyle.lt-md="width:100%">-->
<!--        Για να μπορέσετε να έχετε πλήρη πρόσβαση στην εφαρμογή, θα πρέπει πρώτα να επιβεβαιώσετε και να συμπληρώσετε κάποια απο τα προσωπικά σας στοιχεία.-->
<!--      </div>-->

<!--      <div fxLayout="row" fxFlex fxLayoutAlign="start center center" ngStyle.gt-sm="width:55%" ngStyle.lt-md="width:100%">-->
<!--        Θα θέλαμε να ακολουθήσετε τα εξής βήματα:-->
<!--      </div>-->

<!--      <div fxLayout="row" fxFlex fxLayoutAlign="start center center" ngStyle.gt-sm="width:55%" ngStyle.lt-md="width:100%">-->
<!--        <ol fxLayoutGap="5px">-->
<!--          <li>Επιβεβαιώστε ότι το όνομα και το επώνυμό σας είναι σωστά</li>-->
<!--          <li>Επιλέξτε το email με το οποίο θα συνδέεστε στην εφαρμογή</li>-->
<!--          <li><b>Αλλάξτε</b> τον προσωρινό σας κωδικό σύνδεσης</li>-->
<!--          <li>Εισάγετε το τηλέφωνο επικοινωνίας σας</li>-->
<!--          <li>Επιλέξτε τον τρόπο με τον οποίο η εφαρμογή θα σας στέλνει ειδοποιήσεις</li>-->
<!--        </ol>-->
<!--      </div>-->

<!--      <div fxLayout="row" fxFlex fxLayoutAlign="start center center" ngStyle.gt-sm="width:55%" ngStyle.lt-md="width:100%">-->
<!--        Για οποιαδήποτε πληροφρία επικοινωνείστε μαζί μας  στο &nbsp; <a href="mailto:{{contactInfo.college_info_email}}">{{contactInfo.college_info_email}}</a>-->
<!--      </div>-->

<!--    </div>-->

<!--&lt;!&ndash;    <div fxLayout="column" fxFlex fxLayoutAlign="start center center" style="margin-top:50px;">&ndash;&gt;-->
<!--      <app-user-info *ngIf="!isUserInfoLoading && !isProvidersLoading" [user]="currentUser" [providers]="notificationProviders"></app-user-info>-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->


<!--    </div>-->
<!--</div>-->
